var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"script-loading-text"},[_vm._v(" Loading "+_vm._s(_vm.loadingDots)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }